module.exports = __webpack_public_path__ + "static/media/24UHCHR2.0894d4b8.jpg";